import { createApp } from 'vue';
import GlobalFooterColumn from './GlobalFooterColumn.vue';

import './GlobalFooter.scss'

const mountingGlobalFooterColumn = document.querySelector('[data-feature="global-footer-column"]');
if (mountingGlobalFooterColumn) {
    const app = createApp({
        name: 'GlobalFooterApp',
    });
    app.component('global-footer-column', GlobalFooterColumn);
    app.mount(mountingGlobalFooterColumn);
}